module.exports = __webpack_public_path__ + "img/business-3.76bf5b1c.jpg";